var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.0006 7.50377C11.8416 7.50377 13.334 8.99616 13.334 10.8371C13.334 12.6781 11.8416 14.1704 10.0006 14.1704C8.15968 14.1704 6.66729 12.6781 6.66729 10.8371C6.66729 8.99616 8.15968 7.50377 10.0006 7.50377ZM10.0006 8.75377C8.85003 8.75377 7.91729 9.68651 7.91729 10.8371C7.91729 11.9877 8.85003 12.9204 10.0006 12.9204C11.1512 12.9204 12.084 11.9877 12.084 10.8371C12.084 9.68651 11.1512 8.75377 10.0006 8.75377ZM10.0006 4.58325C13.8452 4.58325 17.164 7.20826 18.0849 10.8869C18.1687 11.2218 17.9652 11.5611 17.6304 11.645C17.2955 11.7288 16.9561 11.5253 16.8723 11.1904C16.0899 8.06488 13.2684 5.83325 10.0006 5.83325C6.7314 5.83325 3.90904 8.06681 3.12801 11.1942C3.04437 11.5291 2.70509 11.7328 2.3702 11.6492C2.0353 11.5655 1.83162 11.2262 1.91526 10.8913C2.8345 7.21052 6.15436 4.58325 10.0006 4.58325Z",
    fill: "#222729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeBlack);
export default __webpack_public_path__ + "static/media/icon-eye-black.64b10d2b743896c7a017cf5e09753af1.svg";
export { ForwardRef as ReactComponent };